import React from "react";
import { Tab, Tabs } from "@mui/material";

export default function CampaignTemplateTabs({
  templates,
  activeTemplateId,
  onChange,
  sx,
}) {
  if (templates.length <= 1) {
    return null;
  }

  return (
    <Tabs
      value={activeTemplateId}
      onChange={(_, nextTemplateId) => onChange(nextTemplateId)}
      variant="scrollable"
      allowScrollButtonsMobile
      sx={sx}
    >
      {templates.map((template) => (
        <Tab
          key={template.templateId}
          value={template.templateId}
          label={template.channelLabel}
        />
      ))}
    </Tabs>
  );
}
